import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { LegislationCollection } from '@/types/responses/legislations'

class LegislationService {
  async getLegislationsByFcaServiceAreaIds(
    serviceAreaIds: number[],
  ): Promise<LegislationCollection> {
    const response = await apiService.get<LegislationCollection>(
      `${API_PATH_INTERNAL}/legislations`,
      { params: { 'serviceAreas.id': serviceAreaIds } },
    )

    return response.data
  }
}

const legislationService = new LegislationService()

export default legislationService
